import { format } from 'date-fns';

export const getDateString = (date) => {
  return format(date, 'yyyy-MM-dd');
};

export const strToDate = (str) => {
  const dateStr = str?.match?.(/^\d{4}(?:-\d{2}){2}/)?.[0];
  if (!dateStr) {
    return null;
  }
  const [year, month, day] = dateStr.split('-');
  return new Date(year, Number(month) - 1, day);
};

export const isValidDate = (date) => {
  return !!date && date instanceof Date && !isNaN(date.getTime());
};
